import React, { useMemo } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { RequestedDocumentType } from "../../../graphql/supergraphTypes";
import { infoLabelWrapper } from "./style_vanilla.css";
import { getDocumentStatusInfo } from "./utils";

type DocumentStatusLabelProps = {
  documentTypes: RequestedDocumentType[];
};

export const DocumentStatusLabel: React.FC<DocumentStatusLabelProps> = ({
  documentTypes = [],
}) => {
  const statusInfo = useMemo(() => getDocumentStatusInfo(documentTypes), [documentTypes]);

  return (
    statusInfo && (
      <Flex
        className={infoLabelWrapper}
        aria-live="polite"
        role="status"
        data-testid="document-status-label"
      >
        <Icon
          type={statusInfo.iconType}
          size="small"
          color={statusInfo.color}
          variant="outline"
          aria-hidden="true"
        />
        <Text variant="secondary-sm" color={statusInfo.color}>
          {statusInfo.message}
        </Text>
      </Flex>
    )
  );
};
